import React from 'react';

class LoginForm extends React.Component {
    render() {
        return (
            <div style={styles['login-form-container']}>
                <div style={styles["form-container"]}>
                    <h2 style={styles['h2']}>Login to the Elucd Survey Manager</h2>
                    <label style={styles["label"]} htmlFor="email">email</label>
                    <input
                        id="email"
                        type="text"
                        value={this.props.email}
                        onChange={this.props.handleEmailChange}
                        required
                        autoFocus
                        style={styles["input"]}
                    />
                    <label style={styles["label"]} htmlFor="password">password</label>
                    <input
                        id="password"
                        type="password"
                        value={this.props.password}
                        onChange={this.props.handlePasswordChange}
                        placeholder="••••••••"
                        required
                        style={styles["input"]}
                    />

                    <div>
                        {!this.props.isLoading &&
                            <button
                                onClick={this.props.handleSubmit}
                                style={styles['btn-submit']}
                                disabled={this.props.isLoading}
                            >Log In</button>
                        }
                        {/* <div>
                            <a href="/reset_password" className="pw-link">Forgot password?</a>
                        </div> */}
                    </div>
                </div>
            </div>
        );
    }
}

const styles = {
    'h2': {
        padding: 0,
        color: '#0256C5',
        fontWeight: 500,
        textAlign: 'center'
    },
    'form-container': {
        display: 'table',
        position: 'relative',
        maxWidth: 450,
        width: '100%',
        margin: 40
    },
    'login-form-container': {
        width: '100%',
        margin: 'auto',
        marginBottom: 30,
        maxWidth: 450,
    },
    'label': {
        fontSize: 20,
        marginBottom: 8,
        display: 'block',
        textTransform: 'capitalize',
        color: '#0256c5',
        paddingLeft:1+"rem"
    },
    'input': {
        backgroundColor: 'white',
        border: 'none',
        borderBottom: '2px solid #B8D0EF',
        outline: 'none',
        width: '100%',
        height: 3+"rem",
        fontSize: 1+"rem",
        fontWeight: 'regular',
        lineHeight: 1.6,
        marginBottom: 15,
        padding: 1+"rem",
        boxShadow: 'none',
        boxSizing: 'border-box',
        borderRadius: "4px 4px 0 0",
    },
    'btn-submit': {
        display: 'block',
        cursor: 'pointer',
        textAlign: 'center',
        backgroundColor: '#0256c5',
        color: 'white',
        borderRadius: 8,
        fontSize: 20,
        padding: 15,
        border: 0,
        margin: 1 + "rem",
        width: '100%'
    }
}


export default LoginForm;
